export default {
  common: {
    language: "Language",
    switchToEnglish: "Switch to English",
    switchToChinese: "Switch to Chinese",
    confirm: "Confirm",
    cancel: "Cancel",
    noData: "No data",
    confirm: "Confirm",
    cancel: "Cancel",
    pleaseLogin: "Please login",
    paymentFailed: "Payment failed, please try again",
    
    goHome: "Go to Home",
  },
  login: {
    registerTitle: "Registration Successful!",
    registerSuccess: "Congratulations on becoming a yoyotravel member! You’ve received an RM",
    registerSuccessDesc: " New User Coupon — use it now!",
    loggout: "Logout",
    logoutConfirm: "Are you sure you want to log out?",
  },
  tabbar: {
    home: "Home",
    discover: "Discover",
    bookings: "Bookings",
    mine: "Mine",
  },
  home: {
    title: "Home",
    esim: "eSIM",
    sim: "SIM Card",
    search: "Data",
    searchPlaceholder: "Search properties, places",
    hot: "Hot",
    searchText: "Search travel destination",
    favoriteCount: " Likes",
    destinationNotExist: "The destination no longer exists, please search again",
    recentSearch: "Recent Search",
    guessYouWantToSearch: "Guess You Want To Search",
    popularRecommend: "Popular Recommend",
    features: {
      register: "One-click member registration, enjoy various discounts!",
      discount: "Earn Yoyo coins to offset cash!",
      packages: "Coverage of 190+ countries data packages for your choice!",
      esimFree: "No waiting, eSIM auto-delivery after order!",
      simple: "Simple activation, fast and reliable network!",
      gifts: "Birthday gift packages, event discounts, travel packages and more surprises await you!",
    },
    dialog: {
      login: {
        title: "Member registration/login",
        registerDesc: "Please enter your email to register/ sign in",
        codeDesc: "Verification code sent to",
        codeDesc2: ", please enter the verification code within 5 minutes to complete verification",
        codeTip: 'If not received, please check the spam email, or click "Resend" later',
        codePlaceholder: "Enter email address",
        passwordPlaceholder: "Enter password",
        codeLogin: "Email Code Login",
      },
      tip: {
        languageTitle: "Welcome to yoyotravel!",
        languageDesc: "Welcome to yoyotravel! Please select the language you prefer to use.",
        passwordTitle: "Set Login Password",
        passwordDesc:
          "Please set a login password to protect your account and enable quick access.",
        reviewTitle: "You have pending reviews",
        reviewDesc1: "Last order hasn't been reviewed yet!",
        reviewDesc2: "Share 5-star reviews to earn",
        reviewDesc3: "yoyo coins!",
        reviewDesc4: "which can be used for consumption offsetting RM",
        reviewDesc5: "~",
        laterText: "Next time",
        setPasswordText: "Set password",
        chinesetext: "Simplified Chinese",
        englishText: "English",
        reviewText: "Go to review",
        rm5CouponText: "Get RM5 new user coupon",
        iKnowText: "I know",
        reviewText: "Review now",
      },
      register: { 
        title: "Register Now",
        registerDesc: "Quick & easy registration – start enjoying our products & services today!",
        inviteRegisterDesc1: "Your invitation code is",
        inviteRegisterDesc2: "Start enjoying our products & services today!",
      }
    },
    buttons: {
      next: "Next",
      login: "Login",
      register: "Register",
      resend: "Resend",
    },
  },
  products: {
    listNavTitle: "Product List",
    navTitle: "Shopping Cart",
    showMore: "Show more",
    showLess: "Show less",
    showAll: "Show all",
    reviews: "Reviews",
    selectAll: "Select All",
    pleaseSelectProducts: "Please select products to checkout",
    cardEmpty: "The shopping cart is empty",
    cardDesc1: "Free shipping on orders over RM60 (West Malaysia) and RM100 (East Malaysia)",
    cardDesc2: "Spend RM350 and get a surprise gift!",
    cardDesc3: "Register now，new users enjoy RM",
    cardDesc8: " discount!",
    cardDesc4: "",
    cardDesc5: "Members will earn",
    cardDesc6: "yoyoCoins",
    cardDesc7: "redeemable for RM",
    cardBtnText1: "Register now",
    cardBtnText2: "Checkout",
    payNavTitle: "Payment Details",
    // Product detail page translations
    quantity: "Quantity",
    price: "Price",
    addToCart: "Add to Cart",
    buyNow: "Buy Now",
    selectRegion: "Select Region",
    addedToCart: "Added to Cart",
    days: "Days",
    packages: "Packages",
    reviewCount: "reviews",
    // Payment method translations
    paymentMethod: "Payment Method",
    creditCard: "Credit Card/Debit Card",
    onlineBanking: "Online Banking",
    eWallet: "E-Wallet",
    bankCard: "Bank Card",
    cardHolder: "Card Holder",
    expiryDate: "Expiry Date",
    cvv: "CVV",
    saveCardInfo: "Save Bank Card Information",
    cardNumberPlaceholder: "Enter card number",
    cardHolderPlaceholder: "Enter card holder name",
    expiryMonthPlaceholder: "Enter expiry month",
    expiryYearPlaceholder: "Enter expiry year",
    cvvPlaceholder: "Enter CVV",
    // Pay page translations
    shippingAddress: "Shipping Address",
    shippingAddressPlaceholder: "Enter shipping address",
    shippingAddressRequired: "Please fill in shipping address",
    recipient: "Recipient",
    recipientPlaceholder: "Enter recipient name",
    areaCodePlaceholder: "Select area code",
    recipientRequired: "Please fill in recipient name",
    phoneNumber: "Phone Number",
    phoneNumberPlaceholder: "Enter phone number",
    phoneNumberRequired: "Please fill in phone number",
    emailAddress: "Email Address",
    emailAddressRequired: "Please fill in email address",
    emailFormatError: "Please enter correct email format",
    subscribeMarketing: "I agree to receive promotional emails, offers and product updates",
    nonMember: "Not a member?",
    oneClickRegister: "One-click registration",
    getRm5Coupon: "Get RM",
    getRm5Coupon2: " new user coupon",
    loginEarnCoins: "Login now, earn yoyo coins",
    oneClickLogin: "One-click login",
    subtotal: "Subtotal",
    shippingFee: "Shipping Fee",
    freeShippingNote: "(Free shipping on orders over RM60 (West Malaysia) and RM100 (East Malaysia))",
    currentYoyoCoins: "Current yoyo coins:",
    availableYoyoCoins: ", available yoyo coins",
    yoyoDiscount: "(Offset RM",
    coupon: "Coupon",
    totalAmount: "Total Amount",

    registerMember: "Register member",
    registerMemberDiscount: "You can receive a RM5 discount voucher",
    loginMember: "Login member",
    loginMemberDiscount: "You can earn",
    yoyoCoins: "yoyo coins",
    checkout: "Checkout",
    jumpToRegister: "Jump to registration page",
    jumpToLogin: "Jump to login page",
    yoyoUsed: "YoYo coins used, discount RM",
    couponSelected: "Coupon selected: ",
    completeShippingInfo: "Please complete shipping information",
    completePaymentInfo: "Please select payment method",
    processingPayment: "Processing payment...",
    paymentSuccess: "Payment successful!",
    yoyoPointNotEnough: "YoYo coins not enough",
    day: " Day",
    days: " Days",
    paymentChannel: "Payment Channel",

    shopQuantity: "quantity of commodity",
    detail: {
      coverRegion: "Coverage Area",
      productIntro: "Product Details",
      operator: "Network Provider",
      delivery: "Delivery Time",
      notice: "Important Notes",
      activation: "Activation Method",
      supportDevice: "Supported Devices",
      productFAQ: "Product FAQ",
      yoyoCoin: "YoyoCoin",
    },
    settleErr: "Failed to get settlement price, please try again",
    addressErr: "Failed to get default address, please try again",
  },
  query: {
    title: "Query",
    date: "Date",
    queryDate: "Date Range",
    country: "Country",
    status: "Status",
    usage: "Usage",
    statusActive: "Active",
    statusExpired: "Expired",
    statusPending: "Pending",
    noMoreData: "No more data",
    loading: "Loading...",
    refreshing: "Refreshing...",
    bindToAccount: "Bind to my account",
    recharge: "Recharge",
    searchText: "Search SIM ID / iccid",
    alreadyUsed: "Data Used: ",
    tip: "Data usage may be delayed. Please refer to actual usage.",
  },
  discover: {
    description: "Explore more exciting content",
  },
  bookings: {
    description: "View your order history",
  },
  mine: {
    description: "Personal Center",
    malaysia: "Malaysia",
    explorer: "Explorer",
    joined: "Joined",
    years: "years",
    personalInfo: "My Profile",
    myBadges: "My Badges",
    currentPoints: "Total Earned",
    points: "coins",
    currentLevel: "Current level",
    myYoyoCoins: "My YoyoCoins",
    accumulated: "Accumulated",
    used: "Used",
    discountRM: "Discounted RM",
    expireInMonths: "coins will expire in 6 months",
    myCoupons: "My Coupons",
    unused: "Unused",
    newUserRM5: "New user RM5 coupon",
    validUntil2025: "Valid until ",
    pieces: " pieces",
    myOrders: "My Orders",
    reviews: "My Reviews",
    toDo: "My To-Do",
    favorites: "My Favorites",
    binds: "My Linked SIM / eSIM",
    language: "Language Selection",
    customerService: "Official Customer Service",
  },
  userInfo: {
    title: "My Profile",
    name: "Name",
    gender: "Gender",
    birthday: "Birthday",
    country: "Country",
    changePassword: "Change Password",
    email: "Email",
    phone: "Phone Number",
    address: "Address",
    bankCard: "Bank Account/Credit Card",
    malaysia: "Malaysia",
    noReveal: "Prefer not to say",
    male: "Male",
    female: "Female",
    default: "Default",
    addAddress: "Add Address",
    addBankCard: "Add Account/Card",
    editName: "Edit Name",
    editEmail: "Edit Email",
    editPhone: "Edit Phone",
    namePlaceholder: "Please enter name",
    genderPlaceholder: "Please select gender",
    birthdayPlaceholder: "Please select birthday",
    countryPlaceholder: "Please enter country",
    emailPlaceholder: "Please enter email address",
    phonePlaceholder: "Please enter phone number",
    passwordPlaceholder: "Please enter password",
    updateUserInfo: "Update User Info",
    updateSuccess: "Update Success",
    changePasswordSuccess: "Password changed successfully",
    areaCode: "Area Code",
    postalCode: "Postal Code",
    areaCodePlaceholder: "Please enter area code",
    postalCodePlaceholder: "Please enter postal code",
  },
  address: {
    addAddress: "Add Address",
    editAddress: "Edit Address",
    name: "Name",
    phone: "Phone",
    country: "Country",
    city: "State",
    region: "Region",
    detailAddress: "Detail Address",
    zipCode: "Zip Code",
    setAsDefault: "Set as Default Address",
    save: "Save",
    delete: "Delete",
    namePlaceholder: "Please enter recipient name",
    phonePlaceholder: "Please enter recipient phone",
    phoneNumberPlaceholder: "Recipient phone number",
    countryCodePlaceholder: "Area code",
    countryCodeRequired: "Please select international area code",
    countryPlaceholder: "Please select country",
    cityPlaceholder: "Please select state",
    zipCodePlaceholder: "Please enter zip code",
    regionPlaceholder: "Select Province/City/District",
    detailAddressPlaceholder: "Street, building, floor, room number, etc.",
    nameRequired: "Please enter recipient name",
    phoneRequired: "Please enter recipient phone",
    regionRequired: "Please select region",
    detailAddressRequired: "Please enter detail address",
    addSuccess: "Address added successfully",
    updateSuccess: "Address updated successfully",
    deleteSuccess: "Address deleted successfully",
    saveError: "Failed to save address",
    deleteError: "Failed to delete address",
    deleteConfirm: "Delete Address",
    deleteMessage: "Are you sure you want to delete this address?",
  },
  bankCard: {
    addBankCard: "Add Bank Card",
    editBankCard: "Edit Bank Card",
    name: "Name",
    cardNo: "Card Number",
    expireDate: "Expire Date",
    checksum: "CVV",
    setAsDefault: "Set as Default Bank Card",
    save: "Save",
    delete: "Delete",
    namePlaceholder: "Please enter cardholder name",
    cardNoPlaceholder: "Please enter card number",
    expireDatePlaceholder: "Please select expire date",
    checksumPlaceholder: "Please enter CVV",
    nameRequired: "Please enter cardholder name",
    cardNoRequired: "Please enter card number",
    expireDateRequired: "Please select expire date",
    checksumRequired: "Please enter CVV",
    addSuccess: "Bank card added successfully",
    updateSuccess: "Bank card updated successfully",
    deleteSuccess: "Bank card deleted successfully",
    saveError: "Failed to save bank card",
    deleteError: "Failed to delete bank card",
    deleteConfirm: "Delete Bank Card",
    deleteMessage: "Are you sure you want to delete this bank card?",
  },
  yoyoCoins: {
    title: "My YoyoCoins",
    currentBalance: "Current yoyoCoins",
    expireDate: "coins will expire on",
    expireText: "",
    accumulated: "Total Earned",
    used: "Used",
    discountRM: "Redeemed ",
    received: "Received",
    usageRecord: "Usage Record",
    purchaseEsim: "Purchase eSIM/SIM Card",
    fiveStarReview: "5-Star Review",
    completeProfile: "Complete Profile",
    systemReward: "System Auto Reward",
    signInSuccess: "Sign-in Successful!",
    signInSuccessTitle: "",
    signInSuccessDesc: " yoyoCoins are now in your wallet—use them on your next order!",
  },
  reviews: {
    title: "My Reviews",
    totalReviews: "Total Reviews",
    totalYoyoCount: "Total Coins",
    reviewsCount: "reviews",
    pendingReviews: "Pending Reviews",
    completedReviews: "Completed Reviews",
    tabs: {
      pending: "Pending",
      completed: "Completed",
    },
    orderNumber: "Order Number",
    productName: "Product Name",
    orderDate: "Order Date",
    reviewButton: "Review",
    reviewCompleted: "Reviewed",
    reviewTime: "Review Time",
    rating: "Rating",
    reviewContent: "Review Content",
    noReviews: "No reviews yet",
    noPendingReviews: "No pending reviews",
    noCompletedReviews: "No completed reviews",
    loadMore: "Load More",
    refreshing: "Refreshing...",
    loading: "Loading...",
    stars: "stars",
    reviewPlaceholder: "Please enter your review...",
    submitReview: "Submit Review",
    reviewSuccess: "Review submitted successfully",
    reviewFailed: "Failed to submit review, please try again",
    publish: "Publish",
    reviewMinLength: "Please enter at least 5 characters"
  },
  binds: {
    title: "My Linked SIM / eSIM",
    simCard: "SIM Card",
    esim: "eSIM",
    iccid: "iccid",
    activated: "Activated",
    notActivated: "Not activated",
    exchanged: "Exchanged",
    finished: "Plan ended",
    expired: "Expired",
    query: "Query",
    recharge: "Recharge",
    deleteBinding: "Delete Binding",
    newBinding: "Bind SIM/eSIM",
    note: "Note: Rechargeable within 180 days after activation. No card change needed.",
    noBindings: "No bound SIM cards",
    confirmDelete: "Unbind this SIM/eSIM?",
    deleteSuccess: "Delete successful",
    deleteFailed: "Delete failed",
    addBindingPlaceholder: "Please enter iccid",
    deadline: "Deadline",
  },
  orders: {
    title: "My Orders",
    orderNumber: "Order Number",
    orderTime: "Order Time",
    productContent: "Product Content",
    totalAmount: "Total Amount",
    couponUsed: "Coupon Used",
    status: "Status",
    statusProcessing: "Payment pending",
    statusPending: "Pending Shipment",
    statusShipped: "Shipped",
    statusDelivered: "Delivered",
    statusCancelled: "Cancelled",
    noCoupon: "No coupon used",
    noOrders: "No orders",
    viewDetails: "View Details",
    cancelOrder: "Cancel Order",
    confirmCancel: "Confirm cancel order?",
    cancelSuccess: "Order cancelled successfully",
    cancelFailed: "Failed to cancel order",
  },
  orderDetail: {
    title: "Order Details",
    productInfo: "Product Information",
    orderAmount: "Order Amount",
    productAmount: "Subtotal",
    yoyoCoinDiscount: "YoyoCoins Discount",
    couponDiscount: "Coupon Discount",
    shippingFee: "Shipping Fee",
    actualAmount: "Total Paid",
    receiverInfo: "Receiver Information",
    receiverName: "Receiver Name",
    receiverPhone: "Contact Phone",
    receiverAddress: "Delivery Address",
    email: "Email",
    logisticsInfo: "Logistics Information",
    logisticsCompany: "Logistics Company",
    trackingNumber: "Tracking Number",
    shippingTime: "Shipping Time",
    orderInfo: "Order Information",
    orderNumber: "Order Number",
    serialNumber: "Serial Number",
    createTime: "Order Time",
    payTime: "Payment Time",
    rePay: "Pay Now"
  },
  badges: {
    title: "My Badges",
    currentLevel: "Current Level",
    nextLevel: "Next Level",
    needPoints: "",
    canUpgrade: "yoyoCoins to upgrade",
    badgeList: "Badge Levels",
    benefitsComparison: "Benefits Comparison",
    benefit: "Badge Level",
    points: "yoyoCoin",
    consumeRM1: "Coins per RM1",
    birthdayBenefit: "Birthday Gift",
    exclusiveBenefit: "Exclusive Benefit",
    yoyoCoinValid: "Lifetime Validity",
    freeShipping: "Free Shipping",
    customerService: "Customer Service",
  },
  todo: {
    title: "My To-Do",
    completePersonalInfo: "Complete Your Profile",
    share: "Share on Social Media",
    commentOnTheOrder: "Share a 5-star Review",
    complete3Orders: "Complete 3 Orders",
    complete6Orders: "Complete 6 Orders",
    dailyAttendance: "Collect Daily Coins",
    recommend: "Refer a Friend Bonus",
    register: "Register as a Member",
    contactService: "Contact CS",
    toComplete: "Complete Now",
    copyLink: "Copy Link",
    progress: "Progress",
    completed: "",
    copySuccess: "Copied Successfully",
    goCollect: "Go collect",  
    completed1: "Completed",
    ongoing: "Ongoing",
  },
  foot: {
    about: "About Us",
    contact: "Contact Us",
    follow: "Follow Us",
    payment: "Payment Channel",
  },
  coupons: {
    available: "Available",
    used: "Used",
    expired: "Expired",
    use: "Use",
    noAvailable: "No available coupons",
    noUsed: "No used coupons",
    noExpired: "No expired coupons",
    noCoupons: "No coupons",
  },
  pay: {
    title: "Payment Tips",
    orderTimeout: "Order query timeout, please check later",
    waitingForPayment: "Waiting for payment completion",
    orderSuccess: "Order payment successful",
    PaySuccess: "Payment Successful",
    PayFailed: "Payment Failed",
    PayProcessing: "Payment Processing...",
    goOrderDetail: "View Order",
  },
  recharge: {
    title: "Recharge",
    rechargeNow: "Recharge Now",
  },
}
